export function removeInhibitKeysListener() {
	try {
		if(window.xs_inhibitKeysListener) {
			window.removeEventListener('keydown', window.xs_inhibitKeysListener);
		}
	}catch(err) {
		console.error(err);
	}
}
